import React, { useMemo } from 'react';
import styled from 'styled-components';

import ScrollShadow from '../../../../components/ScrollShadow';
import useGRRoundContext from '../../hooks/useGRRoundContext';
import GRChipContainer from '../GRChip/GRChipContainer';

const NB_MIN_CHIPS_TO_DISPLAY = 4;

const Wrapper = styled(ScrollShadow)`
  overflow-x: hidden;
  padding-top: 3em;
`;

type GRChipListProps = {
  nbActiveBets: number;
};

const GRChipList = ({ nbActiveBets }: GRChipListProps) => {
  const { roundId } = useGRRoundContext();

  const betsPlaceholders: Array<number> = useMemo(() => {
    if (nbActiveBets < NB_MIN_CHIPS_TO_DISPLAY) {
      return [...new Array(NB_MIN_CHIPS_TO_DISPLAY + 1).keys()];
    }
    return [...new Array(nbActiveBets + 2).keys()];
  }, [nbActiveBets]);

  return (
    <Wrapper noScrollbar anchorId={roundId ? `gr-chip-list-${roundId}` : undefined}>
      {betsPlaceholders.map((index) => (
        <GRChipContainer key={`gr-pole-chip-${index}`} index={index} isLast={index === betsPlaceholders.length - 1} />
      ))}
    </Wrapper>
  );
};

export default GRChipList;
